<template>
    <div class="demo-stamp" aria-hidden="true">
        <span class="demo-stamp__label">{{ $t('demoTitle') }}</span>
    </div>
</template>

<script>
// "Demo Mode" stamp over the whole game like the native app; click-through, colors fixed (not event branded)
export default {
    name: 'EspDemoStamp'
}
</script>

<style scoped>
/* z-index 6 = the welcome overlay of the event layout, which follows in the DOM and therefore covers the stamp */
.demo-stamp {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 6;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    pointer-events: none;
}
/* native: #B0A0A0A0, 46sp phone / 82sp tablet, 6dp border, 10dp padding, white glow, rotated -35deg;
   the size follows the viewport so "Demo-Modus" fits a 320px phone on one line, longer translations
   (e.g. Portuguese) wrap to two lines, anything beyond that gets an ellipsis */
.demo-stamp__label {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-width: 90vw;
    padding: 10px;
    border: 6px solid rgba(160, 160, 160, 0.69);
    color: rgba(160, 160, 160, 0.69);
    font-size: clamp(1.75rem, 11vw, 5.125rem);
    font-weight: 700;
    line-height: 1.1;
    text-align: center;
    overflow: hidden;
    text-shadow: 0 0 20px #fff;
    transform: rotate(-35deg);
}
</style>
